const workshops = [
  {
    workshop_id: 'terra',
    value: 1,
    label: 'Terra API',
    endTime: '2025-02-14T21:30:00-08:00',
  },
  {
    workshop_id: 'tesla',
    value: 2,
    label: 'Tesla',
    endTime: '2025-02-14T22:00:00-08:00',
  },
  {
    workshop_id: 'nvidia1',
    value: 3,
    label: 'NVIDIA #1',
    endTime: '2025-02-14T22:30:00-08:00',
  },
  {
    workshop_id: 'perp',
    value: 4,
    label: 'Perplexity',
    endTime: '2025-02-14T23:00:00-08:00',
  },
  {
    workshop_id: 'eigen',
    value: 5,
    label: 'Eigenlayer',
    endTime: '2025-02-14T23:30:00-08:00',
  },
  {
    workshop_id: 'otsuka',
    value: 6,
    label: 'Otsuka Valuenex',
    endTime: '2025-02-15T00:00:00-08:00',
  },
  {
    workshop_id: 'nvidia2',
    value: 7,
    label: 'NVIDIA: Stephen Jones (10:30-11:15)',
    endTime: '2025-02-15T11:15:00-08:00',
  },
  {
    workshop_id: 'groq',
    value: 8,
    label: 'Groq',
    endTime: '2025-02-15T11:30:00-08:00',
  },
  {
    workshop_id: 'intersystems',
    value: 9,
    label: 'Intersystems',
    endTime: '2025-02-15T12:00:00-08:00',
  },
  {
    workshop_id: 'rob',
    value: 10,
    label: 'Robert Wachen Fireside Chat',
    endTime: '2025-02-15T12:00:00-08:00',
  },
  {
    workshop_id: 'vercel',
    value: 11,
    label: 'Vercel',
    endTime: '2025-02-15T13:30:00-08:00',
  },
  {
    workshop_id: 'zoom',
    value: 12,
    label: 'Zoom (1:30-2:15)',
    endTime: '2025-02-15T14:15:00-08:00',
  },
  {
    workshop_id: 'gcp',
    value: 13,
    label: 'Google Cloud',
    endTime: '2025-02-15T15:00:00-08:00',
  },
  {
    workshop_id: 'taisu',
    value: 14,
    label: 'Taisu Ventures',
    endTime: '2025-02-15T15:30:00-08:00',
  },
  {
    workshop_id: 'nvidia3',
    value: 15,
    label: 'NVIDIA #2',
    endTime: '2025-02-15T16:00:00-08:00',
  },
  {
    workshop_id: 'nvisia15',
    value: 16,
    label: 'NVIDIA Panel',
    endTime: '2025-02-15T16:30:00-08:00',
  },
  {
    workshop_id: 'flutterflow',
    value: 17,
    label: 'FlutterFlow',
    endTime: '2025-02-15T16:45:00-08:00',
  },
  {
    workshop_id: 'hrt',
    value: 18,
    label: 'HRT',
    endTime: '2025-02-15T17:00:00-08:00',
  },
  {
    workshop_id: 'elastic',
    value: 19,
    label: 'Elastic',
    endTime: '2025-02-15T17:15:00-08:00',
  },
  {
    workshop_id: 'modal',
    value: 20,
    label: 'Modal',
    endTime: '2025-02-15T17:45:00-08:00',
  },
  {
    workshop_id: 'chroma',
    value: 21,
    label: 'Chroma',
    endTime: '2025-02-15T19:15:00-08:00',
  },
  {
    workshop_id: 'codeium',
    value: 22,
    label: 'Codeium',
    endTime: '2025-02-15T19:30:00-08:00',
  },
  {
    workshop_id: 'vespa',
    value: 23,
    label: 'Vespa',
    endTime: '2025-02-15T19:45:00-08:00',
  },
  {
    workshop_id: 'pear',
    value: 24,
    label: 'Pear',
    endTime: '2025-02-15T20:15:00-08:00',
  },
  {
    workshop_id: 'rox',
    value: 25,
    label: 'Rox',
    endTime: '2025-02-15T21:15:00-08:00',
  },
  {
    worskhop_id: 'scrapybara',
    value: 26,
    label: 'Scrapybara',
    endTime: '2025-02-15T21:45:00-08:00',
  },
];

export default workshops;
